import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-radio-widget-selection',
  templateUrl: './radio-widget-selection.component.html',
  styleUrls: ['./radio-widget-selection.component.scss'],
  standalone: false
})
export class RadioWidgetSelectionComponent {
  
  @Input() label: string = '';
  @Input() options: { title: string, text: string }[] = [];
  @Input() selectedOption?: { title: string, text: string };
  @Output() selectedOptionChange = new EventEmitter<{ title: string, text: string }>();

  ngOnInit() {}

  selectOption(option: { title: string, text: string }) {
    this.selectedOption = option;
    this.selectedOptionChange.emit(option);
  }
}